export type AdditionaMarker = { myType: string };

/**
 * Is used to determine, what options the user can choose.
 */
export enum MapSettingType {
  Standard, // 0
  Metric, // 1
  CompareMetric, // 2
  Effectiveness, // 3
  BestAlternative, // 4
}

/**
 * Is used to choose, what layers should be displayed
 */
export enum MapType {
  Distance, // 0
  AbsoluteTime, // 1
  RelativeDifference, // 2
  AbsoluteDifference, // 3
  BestTransport, // 4
  BestAlternative, // 5
  MultipleAlternatives, // 6
}
